import React, { Component } from 'react';
import styled from 'styled-components';
import { Radio } from 'partials/formElements';

export class PeriodSelector extends Component {
    
    constructor(props) {
        super(props)
        this.state = {
            selectedOption: this.props.value,
        }
    }

    componentDidUpdate(nextProps) {
        if(nextProps.value !== this.props.value) {
            this.setState({selectedOption: this.props.value})
        }
    }
    
    render() {

        return (
            <Wrapper>
                <Radio 
                    type="radio" 
                    name="høst" 
                    value="Høst" 
                    checked={this.state.selectedOption === "Høst" || this.state.selectedOption === "Helår"} 
                    onChange={e => this.props.handleOptionChange(e.target.value)}
                    label="Høst"
                    white
                />
                <Radio 
                    type="radio" 
                    name="vår" 
                    value="Vår" 
                    checked={this.state.selectedOption === "Vår"}
                    onChange={e => this.props.handleOptionChange(e.target.value)}
                    label="Vår"
                    white
                />
            </Wrapper>
        )
    }
}

export default PeriodSelector;

const Wrapper = styled.div`
    display: flex; 
    label {
        color: #fff;
        margin: 0 20px 0 0; 
    }
    @media(max-width: 767px){
        label{        
            margin: 0 10px 0 0; 
        }
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/TimePlanNew/courseSelect/PeriodSelector.js